function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import _globalThis from "@babel/runtime-corejs3/core-js/global-this";
import { CookieStorage } from "cookie-storage";
import defaultSecure from "./defaultSecure/index.js";
export var SESSION_TOKEN = 'xo-session-token';
var DOMAIN = '.theknot.com';
var SESSION_TOKEN_DAYS_TO_LIVE = 30; /* days */

var daysInTheFuture = function daysInTheFuture(offset) {
  var date = new Date();
  date.setDate(date.getDate() + offset);
  return date;
};
var cookieConfig = {
  internal: {
    secure: defaultSecure(),
    sameSite: 'Lax',
    cookieName: SESSION_TOKEN,
    cookieExpiration: SESSION_TOKEN_DAYS_TO_LIVE
  },
  external: {
    secure: true,
    sameSite: 'None',
    cookieName: 'xo-cross-site-session-token',
    cookieExpiration: 7 /* days */
  }
};

var createCookieStorage = function createCookieStorage(_ref) {
  var secure = _ref.secure,
    sameSite = _ref.sameSite;
  var options = {
    path: '/',
    domain: process.env.UNION_MEMBERSHIP_COOKIE_DOMAIN || DOMAIN,
    secure: secure,
    sameSite: sameSite
  };
  return new CookieStorage(options);
};
var MembershipBrowserPersistence = /*#__PURE__*/function () {
  function MembershipBrowserPersistence() {
    _classCallCheck(this, MembershipBrowserPersistence);
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref3$useExternalCook = _ref3.useExternalCookieConfig,
      useExternalCookieConfig = _ref3$useExternalCook === void 0 ? false : _ref3$useExternalCook,
      storage = _ref3.storage;
    var cookieOptions = useExternalCookieConfig ? cookieConfig.external : cookieConfig.internal;
    this.storage = storage || createCookieStorage({
      secure: cookieOptions.secure,
      sameSite: cookieOptions.sameSite
    });
    this.sessionTokenCookie = cookieOptions.cookieName;
    this.sessionTokenExpiration = cookieOptions.cookieExpiration;
  }
  _createClass(MembershipBrowserPersistence, [{
    key: "onLogIn",
    value: function onLogIn(_ref2) {
      var _this = this;
      var token = _ref2.token,
        _ref2$tokenExpiration = _ref2.tokenExpirationDate,
        tokenExpirationDate = _ref2$tokenExpiration === void 0 ? daysInTheFuture(this.sessionTokenExpiration) : _ref2$tokenExpiration;
      if (_globalThis.UnionConsentManagement) {
        _globalThis.UnionConsentManagement.onConsentedToNecessary(function () {
          _this.storage.setItem(_this.sessionTokenCookie, token, {
            expires: tokenExpirationDate
          });
        });
      } else {
        this.storage.setItem(this.sessionTokenCookie, token, {
          expires: tokenExpirationDate
        });
      }
    }
  }, {
    key: "getBrandVersion",
    value: function getBrandVersion() {
      return this.storage.getItem('tk_catalyst_variant') === 'b01' ? '2023.1' : null;
    }
  }, {
    key: "getSessionToken",
    value: function getSessionToken() {
      return this.storage.getItem(this.sessionTokenCookie);
    }
  }, {
    key: "deleteSessionToken",
    value: function deleteSessionToken() {
      return this.storage.removeItem(this.sessionTokenCookie);
    }
  }]);
  return MembershipBrowserPersistence;
}();
export { MembershipBrowserPersistence as default };